module.exports = __webpack_public_path__ + "img/Photo-P-Kalozoumis.ac57790e.jpg";